import { IPurchasable } from "@smartrr/shared/entities/Purchasable";
import { useMemo } from "react";

interface usePurchasableOptionsProps {
  purchasables: IPurchasable[];
  searchText: string;
}

export function usePurchasableOptions({ purchasables, searchText }: usePurchasableOptionsProps) {
  return useMemo(() => {
    const filteredAndSortedPurchasables = purchasables
      .filter(p => Boolean(p.shopifyId) && !p.isDraftOrArchived)
      .sort((a, b) => a.purchasableName.localeCompare(b.purchasableName));

    if (!searchText) {
      return filteredAndSortedPurchasables;
    }

    return filteredAndSortedPurchasables.filter(p =>
      p.purchasableName.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [purchasables, searchText]);
}
